/* eslint-disable prettier/prettier */
export const loopTemplatesByOrg = /* GraphQL */ `
  query LoopEventTemplatesByOrg(
    $orgID: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    getOrganization(id: $orgID) {
      loopEvents(
        sortDirection: $sortDirection
        filter: {
          and: [
            { is_template: { eq: true } },
            { eventConfigID: { attributeExists: true } }
          ]
        }
        limit: $limit
        nextToken: $nextToken
      ) {
        items {
          orgID
          date
          id
          is_template
          template_name
          template_description
          eventleadID
          designatedRCID
          recruitingPOCID
        }
        nextToken
      }
    }
  }
`;

export const getLoopEventsByInterviewerProfile = /* GraphQL */ `
  query getLoopEventsByInterviewerProfile(
    $profileID: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listInterviewersByProfile(
      profileID: $profileID
      sortDirection: $sortDirection
      filter: { loopEventID: { attributeExists: true } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        loopEvent {
          id
          maxcandidates
          taglist
          status
          restrictedLeadSignup
          restrictedShadowSignup
          prebriefBookingEnabled
          location
          date
          eventstarttime
          eventendtime
          virtualevent
          createdAt
          orgID
          locked
          lockedby {
            id
            alias
            name
          }
          eventlead {
            id
            alias
            name
          }
          designatedRC {
            id
            alias
            name
          }
          recruitingPOC {
            id
            alias
            name
          }
          eventConfig {
            id
            brMode
            candidateLevels
            name
            description
            duration
            breakDuration
            maxShadowParticipants
            updatedAt
            createdAt
            isActive
            orgID
            isPushRouting
            participantConfigs {
              items {
                id
                orgID
                isActive
                name
                description
                calibrationConfigID
                createdAt
                updatedAt
              }
            }
          }
          candidates {
            items {
              city
              hireurl
              id
              level
              name
            }
          }
          comments(filter: { or: [{ commentType: { eq: EVENT } }, { commentType: { eq: CANCELLATION } }] }) {
            items {
              id
            }
          }
          interviewers {
            items {
              id
              interviewerRole
              participantConfigID
              isBarRaiserInterviewer
              startDateTime
              endDateTime
              sourceOrgID
              profile {
                id
                alias
                languages(
                  limit: 1000,
                  filter: {
                    or: [
                      { reading: { eq: FLUENT_OR_NATIVE }},
                      { speaking: { eq: FLUENT_OR_NATIVE }},
                      { writing: { eq: FLUENT_OR_NATIVE }},
                    ]
                  }
                ) {
                  items {
                    isoCode
                    reading
                    speaking
                    writing
                  }
                }
                name
                preferredTimezoneId
                title
              }
            }
          }
          languages {
            items {
              isoCode
              readingRequired
              speakingRequired
              writingRequired
            }
          }
          updatedAt
        }
      }
      nextToken
    }
  }
`;
 
export const getLoopEventsbyOrg = /* GraphQL */ `
  query GetOrgLoopEvents(
    $orgID: ID!
    $statusDate: ModelLoopEventByOrgStatusDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $loopsFilter: ModelLoopEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrganization(id: $orgID) {
      id
      name
      loopEvents(
        statusDate: $statusDate,
        filter: $loopsFilter,
        limit: $limit,
        nextToken: $nextToken,
        sortDirection: $sortDirection
      ) {
        items {
          id
          maxcandidates
          taglist
          status
          restrictedLeadSignup
          restrictedShadowSignup
          prebriefBookingEnabled
          location
          date
          eventstarttime
          eventendtime
          virtualevent
          createdAt
          orgID
          locked
          lockedby {
            id
            alias
            name
          }
          eventlead {
            id
            alias
            name
          }
          designatedRC {
            id
            alias
            name
          }
          recruitingPOC {
            id
            alias
            name
          }
          eventConfig {
            id
            orgID
            createdAt
            updatedAt
            brMode
            candidateLevels
            name
            description
            duration
            breakDuration
            maxShadowParticipants
            isActive
            isPushRouting
            participantConfigs {
              items {
                id
                orgID
                isActive
                name
                description
                calibrationConfigID
                createdAt
                updatedAt
              }
            }
          }
          candidates {
            items {
              city
              hireurl
              id
              level
              name
            }
          }
          comments(filter: { or: [{ commentType: { eq: EVENT } }, { commentType: { eq: CANCELLATION } }] }) {
            items {
              id
            }
          }
          interviewers {
            items {
              id
              interviewerRole
              participantConfigID
              isBarRaiserInterviewer
              startDateTime
              endDateTime
              sourceOrgID
              profile {
                id
                alias
                languages(
                  limit: 1000,
                  filter: {
                    or: [
                      { reading: { eq: FLUENT_OR_NATIVE }},
                      { speaking: { eq: FLUENT_OR_NATIVE }},
                      { writing: { eq: FLUENT_OR_NATIVE }},
                    ]
                  }
                ) {
                  items {
                    isoCode
                    reading
                    speaking
                    writing
                  }
                }
                name
                preferredTimezoneId
                title
              }
            }
          }
          languages {
            items {
              isoCode
              readingRequired
              speakingRequired
              writingRequired
            }
          }
          routingHistory {
            items {
              createdAt
              id
              endDateTime
              role
              participantConfigID
              createdAt
              profile {
                alias
                email
                id
                name
                title
              }
              scheduleTime
              startDateTime
              state
              isBarRaiser
              updatedAt
            }
          }
          updatedAt
        }
        nextToken
      }
    }
  }
`;

export const getCommentsByLoopEvent = /* GraphQL */ `
  query getCommentsByLoopEvent(
    $loopEventId: ID!
    $limit: Int
    $nextToken: String
  ) {
    getLoopEvent(id: $loopEventId) {
      comments(
        filter: { or: [{ commentType: { eq: CANCELLATION } }, { commentType: { eq: EVENT } }] },
        limit: $limit
        nextToken: $nextToken
      ) {
        items {
          id
          content
          profile {
            id
            alias
            email
            name
            title
          }
          restricted
          loopEventID
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;

export const getLoopConfigsByOrg = /* GraphQL */ `
  query GetLoopConfigsByOrg(
    $orgID: ID!
    $filter: ModelOrgLoopPSConfigurationsFilterInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listConfigsByOrgType(
      orgID: $orgID
      configType: { eq: "LOOP_CONFIG" }
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        configType
        group
        isActive
        brMode
        candidateLevels
        name
        isPushRouting
        description
        duration
        breakDuration
        maxShadowParticipants
        participantConfigs {
          items {
            id
            orgID
            configType
            group
            isActive
            name
            description
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getLoopConfigDefinition = /* GraphQL */ `
  query GetLoopEventConfigDefinition($id: ID!) {
    getOrgLoopPSConfigurations(id: $id) {
      id
      orgID
      group
      isActive
      isPushRouting
      brMode
      candidateLevels
      name
      description
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      participantConfigs {
        items {
          id
          orgID
          configType
          group
          isActive
          name
          description
          calibrationConfigID
          calibrationConfig {
            id
            orgID
            configType
            group
            isActive
            name
            description
            maxShadowPoolSize
            minShadows
            minIndependent
            minReverseShadows
            minShepherdReviews
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const getLoopEvent = /* GraphQL */ `
  query GetLoopEvent($id: ID!) {
    getLoopEvent(id: $id) {
      id
      date
      eventstarttime
      eventendtime
      eventlead {
        id
        alias
        name
        email
        br
      }
      status
      locked
      lockedby {
        id
        alias
        name
      }
      prebriefbooked
      prebriefNote
      debriefbooked
      debriefNote
      calendarplaceholdersent
      virtualevent
      recruitingPOC {
        id
        alias
        name
      }
      designatedRC {
        id
        alias
        name
      }
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      taglist
      maxcandidates
      orgID
      candidates {
        items {
          city
          hireurl
          id
          level
          name
        }
      }
      comments(filter: { or: [{ commentType: { eq: EVENT } }, { commentType: { eq: CANCELLATION } }] }) {
        items {
          id
        }
      }
      interviewers {
        items {
          id
          profile {
            id
            alias
            languages(
              limit: 1000,
              filter: {
                or: [
                  { reading: { eq: FLUENT_OR_NATIVE }},
                  { speaking: { eq: FLUENT_OR_NATIVE }},
                  { writing: { eq: FLUENT_OR_NATIVE }},
                ]
              }
            ) {
              items {
                isoCode
                reading
                speaking
                writing
              }
            }
            name
            preferredTimezoneId
            title
          }
          interviewerRole
          isBarRaiserInterviewer
          sendCalendarInvite
          participantConfigID
          startDateTime
          endDateTime
          sourceOrgID
        }
      }
      eventConfig {
        id
        orgID
        configType
        group
        isActive
        isPushRouting
        brMode
        candidateLevels
        name
        description
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        participantConfigs {
          items {
            id
            orgID
            configType
            group
            isActive
            name
            description
            calibrationConfigID
            calibrationConfig {
              id
              orgID
              configType
              group
              isActive
              candidateLevels
              name
              description
              maxShadowPoolSize
              minShadows
              minIndependent
              minReverseShadows
              minShepherdReviews
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      languages {
        items {
          isoCode
          readingRequired
          speakingRequired
          writingRequired
        }
      }
      location
      createdAt
      updatedAt
      routingHistory {
        items {
          createdAt
          endDateTime
          id
          isBarRaiser
          participantConfigID
          profile {
            alias
            id
            name
            email
            title
          }
          role
          scheduleTime
          startDateTime
          state
          updatedAt
        }
      }
    }
  }
`;

export const getLoopEventInterviewers = /* GraphQL */ `
  query GetInterviewersByLoopEvent(
    $eventID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInterviewerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getLoopEvent(id: $eventID) {
      interviewers(
        sortDirection: $sortDirection
        filter: $filter
        limit: $limit
        nextToken: $nextToken
      ) {
        items {
          id
          profileID
          participantConfigID
          interviewerRole
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const listLanguagesByEvent = /* GraphQL */ `
  query listLanguagesByEvent($eventId: ID!) {
    listLanguages(id: $eventId, recordTypeIsoCode: { beginsWith: { recordType: REQUIREMENT } }) {
      items {
        id
        isoCode
        readingRequired
        speakingRequired
        writingRequired
      }
    }
  }
`;
